import PropTypes from 'prop-types';
import { Box, Button, Skeleton, Stack, Typography } from '@mui/material';
import { useOrganizationHistory } from '../../hooks/useOrganizationOverview';
import { overviewErrorMessage } from '../../services/overview';
import EvolutionChart from './EvolutionChart';
import { t } from '../../i18n';

export default function OverviewHistory({ actor, kind, overview }) {
    const query = useOrganizationHistory(actor, kind, overview.isSuccess);
    const error = overview.isError ? overview.error : query.error;
    const title = kind === 'patients' ? 'Evolução dos pacientes' : 'Planos em curso';
    if (error) return <Stack sx={{ height: '100%', minHeight: 0 }} spacing={1}>
        <Typography component="h2" variant="h4" color="primary.main" sx={{ fontSize: { xs: 15, sm: 17 } }}>{t(title)}</Typography>
        <Stack role="alert" justifyContent="center" sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }} spacing={1}>
            <Typography variant="body2" color="text.secondary">{t(overviewErrorMessage(error))}</Typography>
            <Button size="small" disabled={overview.isFetching || query.isFetching} sx={{ alignSelf: 'flex-start' }}
                onClick={() => overview.isError ? overview.refetch() : query.refetch()}>{t('Tentar novamente')}</Button>
        </Stack>
    </Stack>;
    if (query.isPending) return <Box role="status" aria-label={t('A carregar evolução mensal')}
        sx={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography component="h2" variant="h4" color="primary.main" sx={{ fontSize: { xs: 15, sm: 17 } }}>{t(title)}</Typography>
        <Skeleton width="65%" height={14} />
        <Skeleton variant="rounded" sx={{ flex: 1, minHeight: 0, transform: 'none',
            animationDuration: '2.2s', '@media (prefers-reduced-motion: reduce)': { animation: 'none' } }} />
    </Box>;
    return <EvolutionChart data={query.data} metric={kind === 'patients' ? 'patients' : 'ongoing_patient_plans'} title={title}
        description={kind === 'patients'
            ? 'Registos até ao final de cada mês; exclui pacientes atualmente desativados.'
            : 'Planos em curso no final de cada mês; exclui pacientes atualmente desativados.'}
        color={kind === 'patients' ? '#103B66' : '#1976D2'} />;
}
OverviewHistory.propTypes = { actor: PropTypes.object.isRequired, kind: PropTypes.string.isRequired, overview: PropTypes.object.isRequired };
